(()=>{
  if(window.mmRedesignLoaded)return;window.mmRedesignLoaded=true;
  if(window.Shopify?.loadFeatures&&!window.Shopify.customerPrivacy){
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],()=>{});
  }
  function init(root){
    if(root.dataset.mmReady)return;root.dataset.mmReady='true';
    const button=root.querySelector('[data-menu]'),nav=root.querySelector('[data-nav]');
    function close(){nav?.classList.remove('is-open');button?.setAttribute('aria-expanded','false');}
    button?.addEventListener('click',()=>{const open=button.getAttribute('aria-expanded')!=='true';button.setAttribute('aria-expanded',String(open));nav?.classList.toggle('is-open',open);if(open)nav?.querySelector('a')?.focus();});
    root.addEventListener('keydown',e=>{if(e.key==='Escape'&&button?.getAttribute('aria-expanded')==='true'){close();button.focus();}});
    document.addEventListener('click',e=>{if(nav?.classList.contains('is-open')&&!root.contains(e.target))close();});
    root.addEventListener('click',e=>{
      const link=e.target.closest('a');if(!link)return;
      if(nav?.contains(link))close();
      if(!link.dataset.event)return;
      // Dispatch only after the existing Shopify consent manager permits analytics.
      // GTM must be configured to consume these events; this code adds no trackers.
      const allowed=window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.();
      if(allowed!==true)return;
      window.dataLayer=window.dataLayer||[];
      window.dataLayer.push({event:link.dataset.event,store:link.dataset.store||'all',placement:link.dataset.placement||'page',range:link.dataset.range||undefined});
    });
  }
  document.querySelectorAll('[data-mm]').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-mm]').forEach(init));
  document.addEventListener('shopify:block:select',e=>{if(e.target.matches('details'))e.target.open=true;});
})();
